const MagnifierIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="4" fill="var(--primary)" />
      <path
        d="M20.8286 20.0057L17.4629 16.64C18.2971 15.6229 18.8 14.32 18.8 12.9C18.8 9.64286 16.1571 7 12.9 7C9.64 7 7 9.64286 7 12.9C7 16.1571 9.64 18.8 12.9 18.8C14.32 18.8 15.62 18.3 16.6371 17.4657L20.0029 20.8286C20.2314 21.0571 20.6 21.0571 20.8286 20.8286C21.0571 20.6029 21.0571 20.2314 20.8286 20.0057ZM12.9 17.6257C10.2914 17.6257 8.17143 15.5057 8.17143 12.9C8.17143 10.2943 10.2914 8.17143 12.9 8.17143C15.5057 8.17143 17.6286 10.2943 17.6286 12.9C17.6286 15.5057 15.5057 17.6257 12.9 17.6257Z"
        fill="white"
        stroke="white"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default MagnifierIcon;
